import type { Friend } from "./types"

/** Статусы, при которых друг считается «новым» (экран «Новые», счётчик в хедере) */
export const NEW_FRIEND_STATUSES: ReadonlySet<Friend["status"]> = new Set([
	"incoming",
	"outgoing",
])

/** Badge types for UI (extends Friend["source"] with UI-specific values) */
export type FriendBadgeType = Friend["source"] | "checked" | "blocked"
